import { RewardsBundle } from 'api/optimalprint-sdk.d';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CancellationConfirmationPageType,
  CancellationFlowStep,
  CancellationReasonsType,
  CancellationResultType,
  OpPlusV3Info,
  SubscriptionData,
} from './types';

export type DashboardState = {
  subscriptionData: SubscriptionData | null;
  cancellationFlowStep: CancellationFlowStep | null;
  cancellationResult: CancellationResultType | null;
  cancellationConfirmationPage: CancellationConfirmationPageType | null;
  cancellationReasons: CancellationReasonsType | null;
  rewardsStatus: boolean | null;
  rewardsSummary: {
    amount: number;
    amountFormatted: string;
    expireAt: string;
  };
  opPlusV3Info: OpPlusV3Info | null;
};

export const dashboardInitialState: DashboardState = {
  subscriptionData: null,
  cancellationFlowStep: CancellationFlowStep.initial,
  cancellationResult: null,
  cancellationConfirmationPage: null,
  cancellationReasons: null,
  rewardsStatus: null,
  rewardsSummary: {
    amount: 0,
    amountFormatted: '',
    expireAt: '',
  },
  opPlusV3Info: null,
};

export const slice = createSlice({
  name: 'dashboard',
  initialState: dashboardInitialState,
  reducers: {
    setSubscriptionData: (state, action: PayloadAction<SubscriptionData>) => {
      state.subscriptionData = action.payload;
    },
    setCancellationFlowStep: (state, action: PayloadAction<CancellationFlowStep>) => {
      state.cancellationFlowStep = action.payload;
    },
    setCancellationResult: (state, action: PayloadAction<CancellationResultType>) => {
      state.cancellationResult = action.payload;
    },
    setCancellationConfirmationPage: (state, action: PayloadAction<CancellationConfirmationPageType>) => {
      state.cancellationConfirmationPage = action.payload;
    },
    setCancellationReasons: (state, action: PayloadAction<CancellationReasonsType>) => {
      state.cancellationReasons = action.payload;
    },
    setRewardsStatus: (state, action: PayloadAction<boolean>) => {
      state.rewardsStatus = action.payload;
    },
    setPlusMembershipData: (state, action: PayloadAction<OpPlusV3Info>) => {
      state.opPlusV3Info = action.payload;
    },
    setRewardsSummary: (
      state,
      action: PayloadAction<RewardsBundle.Entity.API.RewardsSummaryV1.RewardsSummaryResponse>,
    ) => {
      state.rewardsSummary.amountFormatted = action.payload.amount.formatted;
      state.rewardsSummary.amount = action.payload.amount.value;
      state.rewardsSummary.expireAt = action.payload.expireAt.formatted;
    },
  },
});

export const {
  setSubscriptionData,
  setCancellationFlowStep,
  setCancellationResult,
  setCancellationConfirmationPage,
  setCancellationReasons,
  setRewardsStatus,
  setRewardsSummary,
  setPlusMembershipData,
} = slice.actions;
const { reducer } = slice;
export default reducer;
